const action = "MODEL_CREATE";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const CLEAR = action+'_CLEAR';
export const FAILURE = action+'_FAILURE';

export const createModelRequest = (payload) => {
    return {
        type: REQUEST,
        payload
    };
};

export const createModelSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const clearState = () => ({
  type: CLEAR
});

export const createModelFailure = (error) => ({
  type: FAILURE,
  payload: error
}); 